type PerformLogoutOptions = {
  withoutConfirmation?: boolean
  redirect?: RouteLocationRaw
}

export const performLogout = async ({
  withoutConfirmation,
  redirect,
}: PerformLogoutOptions = {}) => {
  const authStore = useAuthStore()
  const cartStore = useCartStore()
  const modals = useModalManager()
  const route = useRoute()

  const forceLogout = withoutConfirmation || cartStore.isCartEmpty
  if (!forceLogout) {
    modals.show('LogoutConfirm')
    return
  }

  await authStore.logout()

  if (redirect) {
    customNavigateTo(redirect, { redirectCode: 302 })
  } else {
    // ? if user is on account page, redirect to login page
    const isAccountRoute = /^\/(account|kundenkonto)/.test(route.path)
    // ? if user is on epaper page, redirect to epaper login page
    const isEpaperRoute = /^\/epaper/.test(route.path)
    if (isAccountRoute) {
      customNavigateTo({ name: 'login' }, { redirectCode: 302 })
    } else if (isEpaperRoute) {
      customNavigateTo({ name: 'epaper-login' }, { redirectCode: 302 })
    }
  }

  if (modals.isActive('LogoutConfirm'))
    await modals.hide('LogoutConfirm')

  if (authStore.isUserLogoutCallbackSuccess) {
    modals.show('LoggedOut')
  } else if (authStore.isUserLogoutCallbackError) {
    // show error modal based on userLogoutCallback
    onShowLogs(() => console.error(authStore.userLogoutCallback))
  }
}
